module.exports = __webpack_public_path__ + "static/media/insitu.82f82030.svg";